import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { linkCode, linkCodeResponse } from "./TerminalOnboardingData/LinkCode";

const languageMap = {
    curl: 'bash',
    java: 'java',
    "C#": 'csharp',
    python: 'python',
    JavaScript: 'javascript'
};

const LinkTerminalComponent = () => {
    const [selectedLanguageLinkTerminal, setSelectedLanguageLinkTerminal] = useState('curl');
    const [copyStatus, setCopyStatus] = useState({ type: '', isCopied: false });

    const handleSelectedCode = (language) => {
        setSelectedLanguageLinkTerminal(language);
    };

    const handleCopyClick = (type) => {
        const textToCopy = type === 'linkTerminal' ? linkCode[selectedLanguageLinkTerminal].request : linkCodeResponse;
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setCopyStatus({ type, isCopied: true });
                setTimeout(() => {
                    setCopyStatus({ type: '', isCopied: false });
                }, 1000);
            })
            .catch((error) => {
                console.error('Error copying text: ', error);
                alert('Failed to copy text. Please try again.');
            });
    };

    return (
        <section className="docs-section" id="link-terminal">
            <div className="row flexbox">
                <div className="col-md-5">
                    <h2 className="section-heading">Link Terminal Request</h2>
                    <p><span className="badge badge-secondary back-green">POST</span><span className="api"> /in-store/api/v1/terminal/link</span></p>
                    <p>Service to link terminal with serial number using registration code</p>
                    <h4>Request Body</h4>
                    <div className="property-tab col-md-10 border-bottom">
                        <p required><span className="badge badge-secondary name">terminalId</span> &nbsp; &nbsp; <b>string</b></p>
                        <p className="description">Terminal ID</p>
                    </div>
                    <div className="property-tab col-md-10 border-bottom">
                        <p required><span className="badge badge-secondary name">registrationCode</span> &nbsp; &nbsp; <b>string</b></p>
                        <p className="description">Registration Code</p>
                    </div>
                    <br />
                    <div className="response-codes">
                        <h4>Response Codes</h4>
                        <div className="table-wrapper">
                            <h6 className="header">HTTP Status code summary</h6>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>200 Success</td>
                                        <td>Terminal linking was successful. If the terminal is online, backend may have informed the terminal on the linking event and if the terminal is offline, the notification on terminal linking is just stored in the database. Once the terminal comes back online, it will get automatically updated</td>
                                    </tr>
                                    <tr>
                                        <td>400 Bad Request</td>
                                        <td>Bad request format or validation failed for incorrect data formats</td>
                                    </tr>
                                    <tr>
                                        <td>401 Unauthorized</td>
                                        <td>Request requires authentication, and the provided credentials are either missing, invalid, or insufficient, hence send a valid merchant access token (Bearer) issued by Westpay in the "Authorization" header</td>
                                    </tr>
                                    <tr>
                                        <td>422 Client Error</td>
                                        <td>Un-processable request. It could be either due to terminal or merchant not in valid or active state</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-md-7 code-segments">
                    <div className="docs-code-block">
                        <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Request</span>
                                        {Object.keys(linkCode).map(language => (
                                            <React.Fragment key={language}>
                                                <input type="radio" name="langLinkTerminal" id={`${language}LinkTerminal`} onClick={() => handleSelectedCode(language)} checked={selectedLanguageLinkTerminal === language} />
                                                <label htmlFor={`${language}LinkTerminal`} className="language">{language}</label>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'linkTerminal' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("linkTerminal")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'linkTerminal' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language={languageMap[selectedLanguageLinkTerminal]} style={dracula} showLineNumbers>
                                        {linkCode[selectedLanguageLinkTerminal].request}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                    <div className="docs-code-block">
                        <pre tabIndex="-1" className="shadow-lg rounded">
                            <code className="language-dockerfile hljs">
                                <div className="row code-header">
                                    <div className="col-md-10 languages">
                                        <span>Response</span>
                                    </div>
                                    <div className="col-md-2">
                                        {copyStatus.type !== 'linkTerminalResponse' && <span className="copy-btn" title="Copy" onClick={() => handleCopyClick("linkTerminalResponse")}><i className="fa fa-copy"></i></span>}
                                        {copyStatus.type === 'linkTerminalResponse' && copyStatus.isCopied && <div className="copy-message">Copied &#x2713;</div>}
                                    </div>
                                </div>
                                <div className="code-section">
                                    <SyntaxHighlighter language="json" style={dracula} showLineNumbers>
                                        {linkCodeResponse}
                                    </SyntaxHighlighter>
                                </div>
                            </code>
                        </pre>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LinkTerminalComponent;
